/**
 * Every string the pool banner control renders, on web. Mirrored verbatim on
 * mobile in `apps/mobile/src/poolBanner/poolBannerCopy.ts`, so a future test
 * can pin the two against each other.
 *
 * `POOL_BANNER_UPLOAD_FAILED_MESSAGE` is the generic line for a `failed`
 * state that carries no sentence of its own: the upload itself did not
 * happen. It never describes a moderation verdict. ISSUE-944: every upload
 * publishes, whatever the scan concluded, and staff take a flagged banner
 * down from the queue afterwards, so there is no fan-facing "did not pass
 * our check" outcome left for this control to name. The sentence is the
 * profile photo's (`editProfileLogic.ts`), with "image" for "photo".
 */
export const POOL_BANNER_LABEL = "Banner image";
export const POOL_BANNER_EMPTY_MESSAGE =
  "No banner yet. A wide picture looks best here.";
export const POOL_BANNER_ADD_LABEL = "Add a banner";
export const POOL_BANNER_CHANGE_LABEL = "Change banner";
export const POOL_BANNER_REMOVE_LABEL = "Remove banner";
export const POOL_BANNER_UPLOADING_LABEL = "Uploading your banner";
export const POOL_BANNER_UPLOAD_FAILED_MESSAGE =
  "That image didn't upload. Try another one.";
export const POOL_BANNER_PENDING_WITH_BANNER_MESSAGE =
  "We're still checking that image. Your current banner stays up until it's ready.";
export const POOL_BANNER_PENDING_WITH_NONE_MESSAGE =
  "We're still checking that image. Nothing shows at the top of the pool until it's ready.";
export const POOL_BANNER_REMOVE_CONFIRM_TITLE = "Remove this banner?";
export const POOL_BANNER_REMOVE_CONFIRM_BODY =
  "The picture at the top of the pool goes away for everyone in it.";
export const POOL_BANNER_REMOVE_CONFIRM_CANCEL = "Cancel";
export const POOL_BANNER_REMOVE_CONFIRM_CONFIRM = "Remove banner";
